<div class="layout-col full">
  <span style="width: 80vw"></span>

  <app-work-station-detail class="flex" [workStation]="workStation" (close)="onClose($event)">
  </app-work-station-detail>
</div>
